import { Box, IconButton, Title, Text, Link } from '@nimbus-ds/components';
import { CloseIcon } from '@nimbus-ds/icons';
import { Trans } from 'react-i18next';
import useNuvemEnvioTranslations from 'domains/NuvemEnvioCommons/hooks/useNuvemEnvioTranslations/useNuvemEnvioTranslations';
import bannerImageDesktop from './img/banner-ne-desktop.png';
import './BannerDesktop.scss';

interface BannerDesktopProps {
  onClick: () => void;
  onClose: () => void;
  translateKey: string;
}

function BannerDesktop({
  onClick,
  onClose,
  translateKey,
}: Readonly<BannerDesktopProps>) {
  const t = useNuvemEnvioTranslations();

  return (
    <div className="stratus--banner-desktop">
      <div className="banner__close">
        <IconButton
          onClick={onClose}
          backgroundColor="transparent"
          color="neutral-interactive"
          source={<CloseIcon size="small" color="neutral-interactive" />}
        />
      </div>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        flexWrap="wrap"
        height="100%"
        paddingLeft="6"
        paddingRight="6"
        paddingTop="4"
        paddingBottom="4"
      >
        <Box display="flex" alignItems="center">
          <div className="banner__image">
            <img
              src={bannerImageDesktop}
              alt={t(`${translateKey}.title`)}
              height="100%"
              aria-hidden="true"
              decoding="async"
            />
          </div>
        </Box>

        <Box
          display="flex"
          flexDirection="column"
          gap="2"
          flex="1"
          paddingLeft="6"
        >
          <Title as="h3" fontSize="4">
            {t(`${translateKey}.title`)}
          </Title>
          <Text color="primary-textLow" fontSize="caption">
            <Trans
              t={t}
              i18nKey={`${translateKey}.subtitle`}
              components={{ bold: <strong />, 1: <p /> }}
            />
          </Text>
          <Link
            as="button"
            onClick={onClick}
            appearance="primary"
            textDecoration="none"
          >
            {t(`${translateKey}.button`)}
          </Link>
        </Box>
      </Box>
    </div>
  );
}

export default BannerDesktop;
